import React, { useContext, useEffect, useRef, useState } from 'react';

import { useTranslation } from "react-i18next";
import Header from '../components/header';

import {API, getCountries} from '../services/api';
import jwtInterceoptor from '../components/shared/jwtInterceptor';

import { date_formats } from '../services/data';

import moment from 'moment';

import Swal from 'sweetalert2';

import Button from '@mui/material/Button';
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import OrgContext from '../organisation/OrgContext';
import { DataGrid } from '@mui/x-data-grid';
import GoBack from "../components/goBack";
import {ToastContainer, toast} from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { frFR, enUS } from '@mui/x-data-grid';
import {LinearProgress} from "@mui/material";



const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
    padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
    padding: theme.spacing(1),
    },
}));
function BootstrapDialogTitle(props) {
    const { children, onClose, ...other } = props;

    return (
    <DialogTitle sx={{ m: 0, p: 2 }} {...other}>
        {children}
        {onClose ? (
        <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
            }}
        >
            x
        </IconButton>
        ) : null}
    </DialogTitle>
    );
}  

function TaxesList(props) {

    const [t, i18n] = useTranslation();

    const { organisation, changeOrg } = useContext(OrgContext);

    const [organisations, setOrganisations] = useState([]);
    const [taxes, setTaxes] = useState([]);
    const [allTaxes, setAllTaxes] = useState([]);
    const [open, setOpen] = React.useState(false);

    const [update, setUpdate] = useState(false);
    const [selectedTaxe, setSelectedTaxe] = useState(null);
    const [loadingData, setLoadingData] = useState(false);

    const type = useRef("");
    const code_taxe = useRef("");
    const name_taxe = useRef("");
    const rate_taxe = useRef("");
    const type_taxe = useRef("");
    const defaultTaxes = ['44550010', '44550020', '44550014', '44550007', '34552020', '34552014', '34552010', '34552007'];

    useEffect(()=>{

        const fetchTaxes = async () => {
            setLoadingData(true);
            const response = await jwtInterceoptor.get(`/data/organisation_taxes/${organisation.id}`);
    
            if(response.status === 200){
                setAllTaxes(response.data.data);
                let result = response.data.data.filter((tx) => tx.tax_type === "client");
                setTaxes(result);
            }
            setLoadingData(false);
        }
        if(organisation.id){
            fetchTaxes();
        }
        
    }, []);

    const fetchTaxes = async () => {
        setLoadingData(true);
        const response = await jwtInterceoptor.get(`/data/organisation_taxes/${organisation.id}`);

        if(response.status === 200){
            setAllTaxes(response.data.data);
            let result = response.data.data.filter((tx) => tx.tax_type === type.current.value);
            setTaxes(result);
        }
        setLoadingData(false);
    }

    const deleteItem = async (taxe) =>{
        Swal.fire({
            title: t('Are you sure?'),
            text: t("You won't be able to revert this!"),
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: t('Yes, delete it!'),
            cancelButtonText: t("Cancel")
        }).then(async (result) => {
            if (result.isConfirmed) {
                const response = await jwtInterceoptor.delete(`/data/organisation_taxes/${taxe.id}`);
                if(response.status === 200){
                    if(response.data.status == true){
                        fetchTaxes();


                        Swal.fire(
                            t('Deleted!'),
                            t('Your record has been deleted.'),
                            'success'
                        )

                        return;
                    }
                    
                }

                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
                
            }
        })
    }

    const loadTaxes = () => {
        if(type.current.value !== ""){
            let result = allTaxes.filter((tx) => tx.tax_type === type.current.value);
            setTaxes(result);
        }
    }

    const handleClickOpen = () => {
        setOpen(true);
    };
    const handleClose = () => {
        setOpen(false);
        code_taxe.current.value = "";
        name_taxe.current.value = "";
        rate_taxe.current.value = "";
        setUpdate(false);
        setSelectedTaxe(null);
    };

    const saveTaxe = async () => {
        if(
            code_taxe.current.value.trim().length > 0
            && name_taxe.current.value.trim().length > 0
            && rate_taxe.current.value.trim().length > 0
            && type_taxe.current.value.trim().length > 0
        ){
            try {

                let formData = new FormData();

                formData.append("type", type_taxe.current.value);
                formData.append("code", code_taxe.current.value);
                formData.append("name", name_taxe.current.value);
                formData.append("rate", rate_taxe.current.value);
                formData.append("organisation_id", organisation.id);

                const response = await jwtInterceoptor.post(
                    "/data/organisation_taxes",
                    formData,
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if (response.status == 200) {
                    if (response.data.status == true) {
                        fetchTaxes();


                        handleClose();
                        Swal.fire({
                            icon: 'success',
                            text: t(response.data.message),
                        });

                    } else {
                        Swal.fire({
                            icon: 'warning',
                            title: '',
                            text: t(response.data.message),
                        });
                    }
                } else {
                    Swal.fire({
                        icon: 'warning',
                        title: '',
                        text: t('Something went wrong!, try again'),
                    });
                }


            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Fill all fields'),
            });
        }
    }


    const updateTaxe = async () => {
        if(
            code_taxe.current.value.trim().length > 0
            && name_taxe.current.value.trim().length > 0
            && rate_taxe.current.value.trim().length > 0
            && type_taxe.current.value.trim().length > 0
            && selectedTaxe != null
        ){
            try {

                let formData = new FormData();

                formData.append("id", selectedTaxe.id);
                formData.append("type", type_taxe.current.value);
                formData.append("code", code_taxe.current.value);
                formData.append("name", name_taxe.current.value);
                formData.append("rate", rate_taxe.current.value);
                formData.append("organisation_id", organisation.id);

                const response = await jwtInterceoptor.put(
                    "/data/organisation_taxes",
                    formData, 
                    {
                        headers: {
                            'Content-Type': 'application/json'
                        }
                    }
                );

                if(response.status == 200){
                    if(response.data.status == true){
                        fetchTaxes();
                        

                        handleClose();
                        Swal.fire({
                            icon: 'success',
                            text: t(response.data.message),
                        });
                        
                    }else{
                        Swal.fire({
                            icon: 'warning',
                            title: '',
                            text: t(response.data.message),
                        });
                    }
                }else{
                    Swal.fire({
                        icon: 'warning',
                        title: '',
                        text: t('Something went wrong!, try again'),
                    });
                }

                
            } catch (error) {
                console.error(error);
                Swal.fire({
                    icon: 'warning',
                    title: '',
                    text: t('Something went wrong!, try again'),
                });
            }
        }else{
            Swal.fire({
                icon: 'warning',
                title: '',
                text: t('Fill all fields'),
            });
        }
    }

    const open_update = async (c) => {
        setOpen(true);
        setUpdate(true);
        setSelectedTaxe(c);
        await new Promise(r => setTimeout(r, 200));
        console.log("code_taxe.current.value", code_taxe.current.value);
        code_taxe.current.value = c.code;
        name_taxe.current.value = c.name;
        rate_taxe.current.value = c.rate;
        type_taxe.current.value = c.tax_type;
        
    }

    const columns = [
        { field: 'code', headerName: t("Code"), flex: 1, },
        { field: 'name', headerName: t("Nom"), flex: 1, },
        { field: 'rate', headerName: t("TAUX"), flex: 1, },
        {
            field: 'action',
            headerName: t("ACTIONS"),
            width: 180,
            sortable: false,
            disableClickEventBubbling: true,
            
            renderCell: (params) => {
                const onDelete = (e) => {
                  const currentRow = params.row;
                    if (defaultTaxes.indexOf(params.row.code) !== -1) {
                        const errorMessage = 'Vous pouvez pas supprimer cette impôt puisque il est ajouter par defaut pour vous';
                        toast.error(errorMessage, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }else{
                        return deleteItem(currentRow);
                    }
                };

                const onEdite = (e) => {
                    const currentRow = params.row;
                    if (defaultTaxes.indexOf(params.row.code) !== -1) {
                        const errorMessage = 'Vous pouvez pas modifier cette impôt puisque il est ajouter pour vous par defaut, mais vous pouvez ajouter d\'autre';
                        toast.error(errorMessage, {
                            position: "top-right",
                            autoClose: 5000,
                            hideProgressBar: false,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            theme: "colored",
                        });
                    }else{
                        return open_update(currentRow);
                    }
                };
                
                return (
                    <div className="btn-list">
                        <button onClick={onEdite} type="button" className="btn  btn-sm btn-primary">
                            <span className="fe fe-edit-3"> </span>
                        </button>
                        <button onClick={onDelete} id="bDel" type="button" className="btn  btn-sm btn-danger">
                            <span className="fe fe-trash-2"> </span>
                        </button>
                    </div>
                );
            },
          }
       
    ];

    return (
        <>
            <ToastContainer/>

            <div className="row" style={{ zIndex: 1}}>
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-header container-fluid d-flex justify-content-between align-items-center">
                            <div className="mb-0 card-title">{t("Impôts")}</div>
                            {organisation ? (
                                <Button className="btn btn-primary" variant="outlined" onClick={handleClickOpen}>
                                    {t("Ajouter nouveau")}
                                </Button>
                                ): null
                            }
                        </div>
                        <div className="card-body">
                             <div className="col-md-3 col-sm-12 float-right flex-row">
                                <label className="form-label">{t("Type de taxe")} <span className="text-red"></span></label>
                                <select onChange={loadTaxes} ref={type} className="form-control form-select" >
                                    <option value={"client"}>34210000 - Client</option>
                                    <option value={"fournisseur"}>44110000 - Fournisseur</option>
                                </select>
                            </div> 
                           
                            <br/>
                            <br/>
                           
                            <div className="table-responsive">
                                <div style={{ height: 600, width: '100%' }}>
                                    <DataGrid
                                        rows={taxes}
                                        columns={columns}
                                        pagination={false}
                                        checkboxSelection
                                        localeText={
                                            i18n.language == "fr" ?
                                                frFR.components.MuiDataGrid.defaultProps.localeText :
                                                enUS.components.MuiDataGrid.defaultProps.localeText
                                        }
                                        slots={{
                                            loadingOverlay: LinearProgress,
                                        }}
                                        loading={loadingData}
                                    />
                                </div>
                                {/* <table className="table table-bordered border text-nowrap mb-0" id="new-edit">
                                    <thead>
                                        <tr>
                                            <th>{t("Code")}</th>
                                            <th>{t("Nom")}</th>
                                            <th>{t("TAUX")} (%)</th>
                                            <th name="bstable-actions">{t("Actions")}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {taxes.map((c) => 
                                            <tr key={c.id}>
                                                <td>{c.code}</td>
                                                <td>{c.name}</td>
                                                <td>{c.rate}</td>
                                                <td name="bstable-actions">
                                                    <div className="btn-list">
                                                        <button onClick={()=>{
                                                            deleteItem(c);
                                                        }} id="bDel" type="button" className="btn  btn-sm btn-danger">
                                                            <span className="fe fe-trash-2"> </span>
                                                        </button>

                                                        <button onClick={()=>{
                                                           open_update(c);
                                                        }} type="button" className="btn  btn-sm btn-primary">
                                                            <span className="fe fe-edit-3"> </span>
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table> */}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            
            <BootstrapDialog
                onClose={handleClose}
                aria-labelledby="customized-dialog-title"
                open={open}
            
                style={{ zIndex: 2}}
            >
                <BootstrapDialogTitle id="customized-dialog-title" onClose={handleClose}>
                    {!update ? t("Add new taxe") : t("Update taxe")}
                </BootstrapDialogTitle>
                <DialogContent dividers>
                    <div className="form-group">
                        <label className="form-label">{t("Type")} <span className="text-red">*</span></label>
                        <select ref={type_taxe} defaultValue={type_taxe.current?.value ? type_taxe.current.value : ""} className="form-control form-select" >
                            <option value={"client"}>Client</option>
                            <option value={"fournisseur"}>Fournisseur</option>
                        </select>
                    </div>
                    <div className="form-group">
                        <label className="form-label">{t("Code de la taxe")} <span className="text-red">*</span></label>
                        <input ref={code_taxe} type="text" className="form-control" placeholder={t("Code de la taxe")} />
                    </div>
                    <div className="form-group">
                        <label className="form-label">{t("Nom de la taxe")} <span className="text-red">*</span></label>
                        <input ref={name_taxe} type="text" className="form-control" placeholder={t("Nom de la taxe")} />
                    </div>
                    <div className="form-group">
                        <label className="form-label">{t("Taux (%)")} <span className="text-red">*</span></label>
                        <input ref={rate_taxe} type="text" className="form-control" placeholder={t("Taux (%)")} />
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={handleClose}>
                        {t("Cancel")}
                    </Button>
                    {!update ? (<Button autoFocus onClick={saveTaxe}>
                        {t("Sauvegarder les modifications")}
                    </Button>):
                    (<Button autoFocus onClick={updateTaxe}>
                        {t("Sauvegarder les modifications")}
                    </Button>)}
                </DialogActions>
            </BootstrapDialog>
        </>
    );
}

export default TaxesList;